import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { IconifyIcons } from '@thyme/nashville/src/types/icons'
import { storeToRefs } from 'pinia'
import { performDial } from '@/libs/features/phoneNumbers/dial'
import {
  RESTRICTED_DIAL_WARNING_TEXT,
  RESTRICTED_DIAL_WARNING_TITLE,
} from '@/libs/features/phoneNumbers/restrictedDialNumbers'
import { useRestrictedDialStore } from '@/libs/features/phoneNumbers/restrictedDialStore'

/**
 * Controller for the restricted-number dial warning modal. Reads visibility and
 * the pending call from the store and exposes the two user actions.
 */
export default function () {
  const store = useRestrictedDialStore()
  const { isModalOpen } = storeToRefs(store)

  /**
   * Dismiss the pop-up without calling. The user is expected to email instead.
   */
  function emailInstead() {
    store.close()
  }

  /**
   * Proceed with the call the user originally attempted, then dismiss.
   */
  function callAnyway() {
    const pending = store.pendingDial
    store.close()
    if (pending) {
      void performDial(pending)
    }
  }

  return {
    isModalOpen,
    emailInstead,
    callAnyway,
    warningTitle: RESTRICTED_DIAL_WARNING_TITLE,
    warningText: RESTRICTED_DIAL_WARNING_TEXT,
    iconColor: 'nash-tigerlily800',
    IconifyIcons,
    DialogSize,
  }
}
